export const messages_fr = {
    nameEmpty: "Le nom ne peut pas être vide.",
    emailEmpty: "L'adresse e-mail ne peut pas être vide.",
    emailNotValid: "L'adresse e-mail n'est pas valide, veuillez entrer une adresse e-mail correcte.",
    locationEmpty: "L'emplacement ne peut pas être vide.",
    interests: "Sélectionnez 3 domaines d'intérêt.",
    profileSaved: "Les détails du profil sont sauvegardés.",
    profilePic: "Sauvegarde de la photo de profil.",
    addToFavorites: "Ajouté avec succès à vos favoris",
    removeFromFavorites: "Retiré avec succès de la liste des favoris"
};


// WEBPACK FOOTER //
// ./src/constants/messages_fr.js